var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo3Fc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 593 188.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:#f05b28;}.cls-2{opacity:0.6;}.cls-3{opacity:0.7;}.cls-4{opacity:0.9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523,478.71a43.38,43.38,0,0,1,12.37-1.79c14.38,0,23.81,6.48,23.81,16.22,0,6.07-6.52,11.59-15.72,14,11.44,2.17,19.83,9.59,19.83,18.39C563.3,537.85,552,546,535.1,546a58.1,58.1,0,0,1-14.1-1.79V532.82a25.39,25.39,0,0,0,14.08,4c9.39,0,15.5-4.59,15.5-11.36,0-8-5.71-13.49-14.25-13.49H530v-9h2.93c8.89,0,14.82-3.95,14.82-9.87,0-4.23-4.82-7-12.52-7a20.79,20.79,0,0,0-12.23,4Z",
    transform: "translate(-343 -417)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571,477h41v9H583v21h24v9H583v29H571Z",
    transform: "translate(-343 -417)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M646.48,476.92c18.19,0,30.31,13.82,30.31,34.55S664.67,546,646.48,546s-30.33-13.82-30.33-34.55S628.28,476.92,646.48,476.92Zm0,59.93c10.74,0,17.91-10.15,17.91-25.38s-7.17-25.38-17.91-25.38-17.91,10.15-17.91,25.38S635.72,536.85,646.48,536.85Z",
    transform: "translate(-343 -417)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686,477h21.13c15.14,0,25.24,7.36,25.24,17.94,0,7.4-6.56,13.88-15.81,16.37,8.62,2.28,14.87,7.77,15.81,15.44L734.62,545H722.36l-2.12-18.52c-.88-7.65-6.48-11.48-15.8-11.48H698v30H686Zm21.13,30c8.38,0,14-4.72,14-11.91,0-5.5-5.58-9.09-14-9.09H698v21Z",
    transform: "translate(-343 -417)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M772,546c-19.88,0-33.12-13.82-33.12-34.55s13.22-34.55,33.1-34.55A61.52,61.52,0,0,1,786,478.71v12.12a19.82,19.82,0,0,0-12.64-4c-13.11,0-21.82,9.87-21.82,24.68s8.13,24.68,20.41,24.68c5.41,0,11.06-1.64,14.06-4v12.12A61.45,61.45,0,0,1,772,546Z",
    transform: "translate(-343 -417)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M822.07,476.92c18.2,0,30.33,13.82,30.33,34.55S840.27,546,822.07,546s-30.31-13.82-30.31-34.55S803.89,476.92,822.07,476.92Zm0,59.93c10.75,0,17.92-10.15,17.92-25.38s-7.17-25.38-17.92-25.38-17.91,10.15-17.91,25.38S811.33,536.85,822.07,536.85Z",
    transform: "translate(-343 -417)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861,477h11.57l25.67,46.11L923.91,477H936v68H925V496.95L898.39,544h-.29L872,496.95V545H861Z",
    transform: "translate(-343 -417)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.97 92.64 80.32 103.08 94.09 121.88 109.87 104.89 87.97 92.64"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "115.78 49.38 77.71 64.2 79.03 87.63 79.03 87.63 79.72 100.66 97.33 76.6 115.78 49.38"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "111.47 106.04 88.07 131.29 96.24 129.74 109.21 166.14 135.33 141.71 111.47 106.04"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.27 131.91 71.68 136.23 71.72 136.45 16.82 146.51 56.36 188.94 107.71 167.35 95.27 131.91"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.03 46.84 94.04 0 0 24.05 75.21 63.12 117.03 46.84"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.67 142.45 20.55 127.01 17.05 144.85 29.67 142.45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3Fc);
export default __webpack_public_path__ + "static/media/logo_3fc.03d1eae0b796bb09a8c016aa7ee163f8.svg";
export { ForwardRef as ReactComponent };